module.exports = {
  name: 'Icon Group',
  context: {
    class: 'home-columns',
    heading: {
      text: 'Thriving communities',
      tag: 'h2',
      class: 'heading-4'
    },
    shortDescription: {
      text: 'We do much more than teach a skill or create a plan. We are advocates, ensuring everyone’s rights are respected.',
      tag: 'p',
      class: 'heading-2'
    },
    cards: [
      {
        icon: {
          svg: '<svg width="42" height="40" viewBox="0 0 42 40" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M36.75 14.6708V38.6353H5.29102V14.6708" stroke="#E7F2F2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M17.6094 23.6643H12.1953V29.1095H17.6094V23.6643Z" stroke="#E7F2F2" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/><path d="M29.791 23.6643H21.7656V38.6217H29.791V23.6643Z" stroke="#E7F2F2" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/><path d="M1.36719 17.9598L21 1.36475L40.6328 17.9598" stroke="#E7F2F2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>'
        },
        heading: {
          text: 'Challenge',
          tag: 'h3',
          class: 'heading-3'
        },
        shortDescription: {
          text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Lorem ipsum dolor sit amet, consectetur adipiscing elit.'
        }
      },
      {
        icon: {
          svg: '<svg width="42" height="40" viewBox="0 0 42 40" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M36.75 14.6708V38.6353H5.29102V14.6708" stroke="#E7F2F2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M17.6094 23.6643H12.1953V29.1095H17.6094V23.6643Z" stroke="#E7F2F2" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/><path d="M29.791 23.6643H21.7656V38.6217H29.791V23.6643Z" stroke="#E7F2F2" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/><path d="M1.36719 17.9598L21 1.36475L40.6328 17.9598" stroke="#E7F2F2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>'
        },
        heading: {
          text: 'Solution',
          tag: 'h3',
          class: 'heading-3'
        },
        shortDescription: {
          text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Lorem ipsum dolor sit amet, consectetur adipiscing elit.'
        }
      },
      {
        icon: {
          svg: '<svg width="42" height="40" viewBox="0 0 42 40" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M36.75 14.6708V38.6353H5.29102V14.6708" stroke="#E7F2F2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M17.6094 23.6643H12.1953V29.1095H17.6094V23.6643Z" stroke="#E7F2F2" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/><path d="M29.791 23.6643H21.7656V38.6217H29.791V23.6643Z" stroke="#E7F2F2" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/><path d="M1.36719 17.9598L21 1.36475L40.6328 17.9598" stroke="#E7F2F2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>'
        },
        heading: {
          text: 'Impact',
          tag: 'h3',
          class: 'heading-3'
        },
        shortDescription: {
          text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Lorem ipsum dolor sit amet, consectetur adipiscing elit.'
        }
      },
    ],
  },
  variants: [
    {
      name: 'Icon List',
      context: {
        class: 'icon-list',
        heading: {
          text: 'Heading',
          tag: 'h2',
          class: 'heading-2'
        },
        shortDescription: {
          text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
          tag: 'p',
          class: ''
        },
        cards: [
          {
            icon: {
              svg: '<svg width="42" height="40" viewBox="0 0 42 40" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M36.75 14.6708V38.6353H5.29102V14.6708" stroke="#E7F2F2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M17.6094 23.6643H12.1953V29.1095H17.6094V23.6643Z" stroke="#E7F2F2" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/><path d="M29.791 23.6643H21.7656V38.6217H29.791V23.6643Z" stroke="#E7F2F2" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/><path d="M1.36719 17.9598L21 1.36475L40.6328 17.9598" stroke="#E7F2F2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>'
            },
            heading: {
              text: 'Challenge',
              tag: 'h3',
              class: 'heading-3'
            },
            shortDescription: {
              text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Lorem ipsum dolor sit amet, consectetur adipiscing elit.'
            }
          },
          {
            icon: {
              svg: '<svg width="42" height="40" viewBox="0 0 42 40" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M36.75 14.6708V38.6353H5.29102V14.6708" stroke="#E7F2F2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M17.6094 23.6643H12.1953V29.1095H17.6094V23.6643Z" stroke="#E7F2F2" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/><path d="M29.791 23.6643H21.7656V38.6217H29.791V23.6643Z" stroke="#E7F2F2" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/><path d="M1.36719 17.9598L21 1.36475L40.6328 17.9598" stroke="#E7F2F2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>'
            },
            heading: {
              text: 'Solution',
              tag: 'h3',
              class: 'heading-3'
            },
            shortDescription: {
              text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Lorem ipsum dolor sit amet, consectetur adipiscing elit.'
            }
          },
          {
            icon: {
              svg: '<svg width="42" height="40" viewBox="0 0 42 40" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M36.75 14.6708V38.6353H5.29102V14.6708" stroke="#E7F2F2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M17.6094 23.6643H12.1953V29.1095H17.6094V23.6643Z" stroke="#E7F2F2" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/><path d="M29.791 23.6643H21.7656V38.6217H29.791V23.6643Z" stroke="#E7F2F2" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/><path d="M1.36719 17.9598L21 1.36475L40.6328 17.9598" stroke="#E7F2F2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>'
            },
            heading: {
              text: 'Impact',
              tag: 'h3',
              class: 'heading-3'
            },
            shortDescription: {
              text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Lorem ipsum dolor sit amet, consectetur adipiscing elit.'
            }
          },
        ],
      }
    },
    {
      name: 'Icon Columns Interior',
      context: {
        class: 'icon-columns',
        heading: {
          text: 'Heading',
          tag: 'h2',
          class: 'heading-2'
        },
        shortDescription: {
          text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
          tag: 'p',
          class: ''
        },
        cards: [
          {
            icon: {
              svg: '<svg width="42" height="40" viewBox="0 0 42 40" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M36.75 14.6708V38.6353H5.29102V14.6708" stroke="#E7F2F2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M17.6094 23.6643H12.1953V29.1095H17.6094V23.6643Z" stroke="#E7F2F2" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/><path d="M29.791 23.6643H21.7656V38.6217H29.791V23.6643Z" stroke="#E7F2F2" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/><path d="M1.36719 17.9598L21 1.36475L40.6328 17.9598" stroke="#E7F2F2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>'
            },
            heading: {
              text: 'Impact Stat or Fact',
              tag: 'h3',
              class: 'heading-3'
            },
            shortDescription: {
              text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Lorem ipsum dolor sit amet, consectetur adipiscing elit.'
            }
          },
          {
            icon: {
              svg: '<svg width="42" height="40" viewBox="0 0 42 40" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M36.75 14.6708V38.6353H5.29102V14.6708" stroke="#E7F2F2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M17.6094 23.6643H12.1953V29.1095H17.6094V23.6643Z" stroke="#E7F2F2" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/><path d="M29.791 23.6643H21.7656V38.6217H29.791V23.6643Z" stroke="#E7F2F2" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/><path d="M1.36719 17.9598L21 1.36475L40.6328 17.9598" stroke="#E7F2F2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>'
            },
            heading: {
              text: 'Impact Stat or Fact',
              tag: 'h3',
              class: 'heading-3'
            },
            shortDescription: {
              text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Lorem ipsum dolor sit amet, consectetur adipiscing elit.'
            }
          },
          {
            icon: {
              svg: '<svg width="42" height="40" viewBox="0 0 42 40" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M36.75 14.6708V38.6353H5.29102V14.6708" stroke="#E7F2F2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M17.6094 23.6643H12.1953V29.1095H17.6094V23.6643Z" stroke="#E7F2F2" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/><path d="M29.791 23.6643H21.7656V38.6217H29.791V23.6643Z" stroke="#E7F2F2" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/><path d="M1.36719 17.9598L21 1.36475L40.6328 17.9598" stroke="#E7F2F2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>'
            },
            heading: {
              text: 'Impact Stat or Fact',
              tag: 'h3',
              class: 'heading-3'
            },
            shortDescription: {
              text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Lorem ipsum dolor sit amet, consectetur adipiscing elit.'
            }
          },
        ],
      }
    }
  ]
}